<template>
  <div class="row mx-1">
    <div class="col-6"></div>
    <div class="col-6 d-flex align-items-end">
      <!-- <button
        class="btn bg-gradient-dark mb-0 ms-auto"
        :disable="exportLoading"
        @click="exportTransactions"
      >
        <i class="fas fa-download" v-if="!exportLoading"></i>
        <i class="fa-solid fa-spinner fa-spin-pulse" v-if="exportLoading"></i>
        Export
      </button> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      filter: (state) => state.retailerController.transactionsFilter,
      loading: (state) => state.retailerController.transactionsLoading,
      exportLoading: (state) =>
        state.retailerController.transactionsExportLoading,
    }),
  },
  methods: {
    ...mapActions({
      getTransactions: "retailerController/GetTransactions",
      exportTransactions: "retailerController/ExportTransactions",
    }),
  },
};
</script>

<style>
</style>